import { useSelector } from "react-redux";
import { Route, Routes } from "react-router-dom";
import SurveysList from "./SurveysList";
import PageNotFound from "../pageNoFound";
import AddSurvey from "./AddSurvey";
import AllowedAccess from "../../Layout/AllowedAccess";
import ErrorBoundry from "../../Services/ErrorBoundry";
import EditSurvey from "./EditSurvey";
import FillSurvey from "./FillSurvey";
import SurveyResponses from "./SurveyResponses";
const SurveyRoutes = () =>{
	const { userData } = useSelector((state) => state.user);
    return (
        <Routes>
            <Route
                index
                element={
                    <SurveysList />
                }
            />
            <Route path="add" element={<AllowedAccess
                role={userData.role_slug}
                allowedRoles={["super_admin", "org_admin", "captain", "div_admin"]}
                allowedPermissions={["add_survey"]}
                userPermissions={userData.caps_list}
                renderNoAccess={() => <ErrorBoundry />}
                children={<AddSurvey />}
            />} />
            <Route path="edit" element={<AllowedAccess
                role={userData.role_slug}
                allowedRoles={["super_admin", "org_admin", "captain", "div_admin"]}
                allowedPermissions={["edit_event"]}
                userPermissions={userData.caps_list}
                renderNoAccess={() => <ErrorBoundry />}
                children={<EditSurvey />}
            />} />
            <Route path="fill-survey" element={<FillSurvey />} />
            <Route path="responses" element={<SurveyResponses />} />
            <Route path="*" element={<PageNotFound />} />
        </Routes>
    );
}
export default SurveyRoutes;